// VIBRANIAM-SPACE v2 - MobileDrawer.jsx
// Bottom sheet for mobile: the viewport stays full-width up top (that is the
// thing worth looking at on a phone), everything else - module library, DAG
// editor, export settings - lives in here, reachable by pulling the handle
// up. Content scrolls vertically inside; nothing here talks to the engine,
// it just repositions the existing panels.

import React, { useState } from 'react';

export default function MobileDrawer({ children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 flex flex-col rounded-t-2xl border-t border-white/10 bg-ink-800 shadow-[0_-8px_24px_rgba(0,0,0,0.5)] transition-[height] duration-200 ease-out"
      style={{ height: open ? '72vh' : '56px' }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex min-h-[44px] shrink-0 items-center justify-center gap-2 rounded-t-2xl px-4 py-3 active:bg-white/5"
      >
        <span className="h-1 w-10 rounded-full bg-white/25" />
        <span className="text-[11px] uppercase tracking-wider text-slate-400">
          {open ? 'Chiudi pannello' : 'Moduli · editor · export'}
        </span>
      </button>
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-1 pb-[max(12px,env(safe-area-inset-bottom))]">
        {children}
      </div>
    </div>
  );
}
